<template>
    <div class="img_ind_box">
        <div class="img_ind ind_on1">图一</div>
        <div class="img_ind ind_on2">图二</div>
        <div class="img_ind ind_on3">图三</div>
        <div class="img_ind ind_on4">图四</div>
    </div>
</template>

<script>
    export default {    
        
    }
</script>

<style lang="scss" scoped>
.img_ind_box{
    width: 100%;
    height: 100%;
    .img_ind{
      position: absolute;
      font-size: 12px;
      color: #fff;
      padding: 2px 5px;
      background-color: rgba(0,0,0,0.5);
      border-radius: 3px;
      z-index: 999;
    }
    .ind_on1{
      top: 10px;
      left: 10px;
    }
    .ind_on2{
      left: 53%;
      top: 10px;
      // transform: translateX(-20%);
    }
    .ind_on3{
      top: 53%;
      left: 10px;
    }
    .ind_on4{
      top: 53%;
      left: 53%;
    }
}
</style>